import { useCallback, useRef, useState } from "react";

export function usePageHeight() {
	const cleanupRef = useRef<(() => void) | null>(null);
	const [pageHeight, setPageHeight] = useState<string | null>(null);

	const pageRef = useCallback((pageElement: HTMLDivElement | null) => {
		cleanupRef.current?.();
		cleanupRef.current = null;
		if (!pageElement) return;

		const update = () => {
			const top = pageElement.getBoundingClientRect().top;
			setPageHeight(`calc(100dvh - ${Math.max(0, top)}px)`);
		};
		update();
		window.addEventListener("resize", update);
		const mainContent = document.getElementById("main-body-content");
		const observer = new ResizeObserver(update);
		if (mainContent) observer.observe(mainContent);
		cleanupRef.current = () => {
			window.removeEventListener("resize", update);
			observer.disconnect();
		};
	}, []);

	return { pageRef, pageHeight };
}
